import type {EndpointDirectoryV3, EnvNameV3} from '@smart/endpoint-directory';
import type {ClientConfig} from '@smart/feature-app/react';
import {getLanguageTag} from '@smart/locale-service';

export function getClientConfig(): ClientConfig & {scukCalculatorKey: string} {
  const url = new URL(window.location.href);
  const language = url.searchParams.get(`language`) || `en`;
  const preview = url.searchParams.get(`preview`) === `true`;
  const envName = (process.env.TARGET as EnvNameV3) || (`dev` as EnvNameV3);
  const marketId = url.searchParams.get(`marketId`) || `gb`;
  const scukCalculatorKey = process.env.SCUK_CALCULATOR_KEY || ``;
  const endpointDirectory: EndpointDirectoryV3 = {
    //TODO: Not needed but verify if it's needed
    rotatingVerifySecret: undefined,
    envName,
    preview,
  };

  return {
    endpointDirectory,
    scukCalculatorKey,
    locale: {
      marketId,
      languageTag: getLanguageTag(language, marketId),
      language,
    },
  };
}
